import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Language configuration - English is default
export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧', hreflang: 'en' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦', hreflang: 'uk' },
  { code: 'zh', name: '中文', flag: '🇨🇳', hreflang: 'zh' },
  { code: 'es', name: 'Español', flag: '🇪🇸', hreflang: 'es' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', hreflang: 'ru' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', hreflang: 'de' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', hreflang: 'fr' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', hreflang: 'ja' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭', hreflang: 'th' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳', hreflang: 'hi' },
];

export const languageCodes = languages.map(l => l.code);
export const defaultLanguage = 'en';

// Extract language from URL path (takes priority)
const getLanguageFromPath = () => {
  const path = window.location.pathname;
  const segments = path.split('/').filter(Boolean);
  const firstSegment = segments[0];
  if (firstSegment && languageCodes.includes(firstSegment)) {
    return firstSegment;
  }
  return null; // Return null if no language in URL
};

// Get browser language that matches our supported languages
const getBrowserLanguage = () => {
  // Check navigator.language and navigator.languages
  const browserLangs = navigator.languages || [navigator.language];
  
  for (const lang of browserLangs) {
    // Get the primary language code (e.g., 'en' from 'en-US')
    const primaryLang = lang.split('-')[0].toLowerCase();
    if (languageCodes.includes(primaryLang)) {
      return primaryLang;
    }
  }
  
  return null;
};

// Determine initial language: URL > Browser > Default
const getInitialLanguage = () => {
  // 1. First check URL path (highest priority)
  const urlLang = getLanguageFromPath();
  if (urlLang) {
    return urlLang;
  }
  
  // 2. Check if user has a saved language preference
  const savedLang = localStorage.getItem('i18nextLng');
  if (savedLang && languageCodes.includes(savedLang)) {
    return savedLang;
  }
  
  // 3. Detect from browser language
  const browserLang = getBrowserLanguage();
  if (browserLang) {
    return browserLang;
  }
  
  // 4. Fall back to default
  return defaultLanguage;
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: defaultLanguage,
    debug: false,
    supportedLngs: languageCodes,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Order of language detection
      order: ['path', 'localStorage', 'navigator'],
      // Keys to lookup in localStorage
      lookupLocalStorage: 'i18nextLng',
      // Cache user language
      caches: ['localStorage'],
      // Check for language in path
      lookupFromPathIndex: 0,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;
